import { apiGet } from '@gat-ship/http-client'
import type { EstimatedTimeNameRef } from '@gat-ship/types'

/**
 * Active estimated time names for the current tenant. Returns the lean
 * pick-list shape ({@link EstimatedTimeNameRef}) — the CRUD/admin
 * registry lives in `@gat-ship/estimated-time-names`.
 */
export async function getEstimatedTimeNamesRequest() {
  return await apiGet<EstimatedTimeNameRef[]>('ref-data/time/estimated-names')
}
